export enum ENGINE_TYPES {
  DIESEL = 'diesel',
  ELECTRIC = 'electric',
  GASOLINE = 'gasoline',
  FFV = 'FFV',
  CNG = 'CNG',
}
